<div class="container">


<!-- Create new order-->
@if (data.action != 'edit') {
  <mat-stepper
    linear="true"
    #stepper
    (selectionChange)="selectedTabChange($event)"
    >
    <!-- Step 1 select equipmet -->
    @if (data.action == 'add') {
      <mat-step  [stepControl]="formStepeOne">
        @if (isMobile) {
          <div class="mobile-step-title">
            Selección de equipo
          </div>
        }
        <form [formGroup]="formStepeOne">
          @if (!isMobile) {
            <ng-template class="font" matStepLabel>Selección de equipo</ng-template>
          }
          <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 10px;
        "
            >
            <div
          style="
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
          "
              >
              <div style="width: 50%">
                <data-table
                  title=""
                  [columns]="columnasEquipos"
                  [configuration]="configurationEquipos"
                  [reloadTable]="recargarTablaEquipos"
                  (clickRow)="clickRowEquipment($event)"
                  [params]="params"
                  [url]="urlTablaEquipos"
                  >
                </data-table>
              </div>
              @if (imageSrc != '') {
                <div style="width: 50%; text-align: center">
                  <img
                    class="mat-elevation-z8"
                    src="{{ imageSrc }}"
                    [ngStyle]="sizePicture"
                    />
                  <h2 style="margin-top: 5px">Código: {{ equipo.code }}</h2>
                </div>
              }
              <div style="display: none">
                <mat-form-field>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="equipmentId"
                    matInput
                    required
                    />
                </mat-form-field>
              </div>
            </div>
            @if (imageSrc != '') {
              <button
                matStepperNext
                style="width: 70%; margin-top: 15px"
                color="primary"
                class="button-save mat-elevation-z5"
                mat-raised-button
                >
                Continuar
              </button>
            }
          </div>
        </form>
      </mat-step>
    }
    <!-- Step 2 select type maintenence-->
    @if (data.action == 'add') {
      <mat-step [stepControl]="formStepeTwo">
        <form [formGroup]="formStepeTwo" style="height: 70vh">
          @if (isMobile) {
            <div class="mobile-step-title">
              Tipo de mantenimiento
            </div>
          }
          @if (!isMobile) {
            <ng-template class="font" matStepLabel>Tipo de mantenimiento</ng-template>
          }
          <mat-form-field style="display: none">
            <input
              autocomplete="off"
              type="text"
              formControlName="tipoMtto"
              matInput
              required
              />
          </mat-form-field>
          <app-button-icon
            [items]="buttonstypeOfMaintenance"
            (clickButton)="typeOfMaintenance($event.id)"
          ></app-button-icon>
        </form>
      </mat-step>
    }
    <!-- Step 3 Form maintenence-->
    <mat-step [stepControl]="formOT">
      @if (isMobile) {
        <div class="mobile-step-title">
          {{ typeMaintenance.name }}
        </div>
      }
      @if (!isMobile) {
        <ng-template class="font" matStepLabel>{{
          typeMaintenance.name
        }}</ng-template>
      }
      @if (typeMaintenance.loadPreventiveMaintenance) {
        <div>
          @if (actividad.label == '') {
            <div>
              <div
                class="mat-elevation-z3"
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
          "
                >
                <h3 style="margin: 10px">Mantenimiento preventivo no registrado</h3>
                <button
                  style="background-color: #343a40; color: white"
                  class="mat-elevation-z2"
                  mat-button
                  (click)="jumpSelectActivity()"
                  >
                  <i class="fa fa-arrow-right"></i>
                </button>
              </div>
              <div style="margin-top: 30px">
                <data-table
                  [title]="titleActividades"
                  [columns]="columnasActividades"
                  [configuration]="configurationActividades"
                  [reloadTable]="recargarTablaActividades"
                  (clickRow)="clickFilaActividades($event)"
                  [params]="paramsActividades"
                  [url]="urlGetTablaActividades"
                  >
                </data-table>
              </div>
            </div>
          }
          @if (actividad.label != '') {
            <div>
              @if (!isMobile) {
                <ng-template matStepLabel>{{ actividad.label }}</ng-template>
              }
              <ng-container *ngTemplateOutlet="formWorkOrder"></ng-container>
            </div>
          }
        </div>
      } @else {
        <form
          [formGroup]="formOT"
    (ngSubmit)="
      formOT.valid
        ? data.action != 'edit'
          ? stepper.next()
          : saveOt(formOT.value)
        : errorMessage()
    "
          style="overflow: auto"
          >
          <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
            <div style="display: flex; width: 100%; margin-top: 10px">
              <div [style.flex]="data.action == 'edit' ? 10 : 12">
                <div class="first-row">
                  @if (data.action == 'edit') {
                    <div class="row-item">
                      <mat-form-field>
                        <mat-label># orden</mat-label>
                        <input
                          [value]="data.body.consecutive"
                          matInput
                          readonly
                          placeholder="# orden"
                          />
                      </mat-form-field>
                    </div>
                  }
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Marca</mat-label>
                      <input
                        [value]="equipo.brand"
                        matInput
                        readonly
                        placeholder="Marca"
                        />
                    </mat-form-field>
                  </div>
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Código equipo</mat-label>
                      <input
                        [value]="equipo.code"
                        matInput
                        readonly
                        placeholder="Código equipo"
                        />
                    </mat-form-field>
                  </div>
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Componente</mat-label>
                      <mat-select formControlName="componentId" required>
                        @for (data of componentes; track data) {
                          <mat-option
                            [value]="data.id"
                            >
                            {{ data.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="default-row">
                  <div class="row-item">
                    <mat-form-field [appOpenDatepickerOnClick]="pickerExecuteDate">
                      <mat-label>Fecha ejecución</mat-label>
                      <input
                        [matDatepicker]="pickerExecuteDate"
                        autocomplete="off"
                        matInput
                        required
                        formControlName="executionDate"
                        (ngModelChange)="checkDateRange($event)"
                        />
                      <mat-datepicker-toggle matIconSuffix [for]="pickerExecuteDate">
                      </mat-datepicker-toggle>
                      <mat-datepicker
                        #pickerExecuteDate
                        [touchUi]="isMobile ? true : false"
                      ></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Costo Mantenimiento</mat-label>
                      <input
                        autocomplete="off"
                        type="text"
                        appThousandSeparator
                        formControlName="cost"
                        matInput
                        #costo
                        oninput="this.value = this.value.slice(0,10)"
                        placeholder="Costo Mantenimiento"
                        />
                      <mat-hint>{{ costo.value.length }}/10</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="row-item">
                    <combos
                      [configuration]="combosConfigauthorize"
                      [reloadCombo]="reloadComboauthorize"
                      [required]="true"
                      [filter]="true"
                      [disabled]="data.action == 'edit'"
                      [control]="formOT.get('authorizesId')"
                      >
                    </combos>
                  </div>
                </div>
                <div class="default-row">
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Medidor actual (horas/km/ciclos)</mat-label>
                      <input
                        autocomplete="off"
                        type="text"
                        appThousandSeparator
                        formControlName="currentOdometer"
                        required
                        matInput
                        #o_actual
                        oninput="this.value = this.value.slice(0,7)"
                        placeholder="Medidor actual (horas/km/ciclos)"
                        />
                      <mat-hint>{{ o_actual.value.length }}/8</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="row-item">
                    <combos
                      [configuration]="combosConfigResponsable"
                      [reloadCombo]="reloadComboResponsable"
                      [required]="true"
                      [filter]="true"
                      [disabled]="data.action == 'edit'"
                      [control]="formOT.get('responsibleId')"
                      >
                    </combos>
                  </div>
                  @if (!inventoryModule) {
                    <div class="row-item">
                      <mat-form-field>
                        <mat-label>Recursos</mat-label>
                        <input
                          autocomplete="off"
                          type="text"
                          formControlName="resources"
                          matInput
                          required
                          #recursos
                          maxlength="255"
                          placeholder="Recursos"
                          />
                        <mat-hint>{{ recursos.value.length }}/255</mat-hint>
                        <mat-error>Campo requerido</mat-error>
                      </mat-form-field>
                    </div>
                  }
                </div>
                <div class="default-row">
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>tiempo_estimado (horas)</mat-label>
                      <input
                        autocomplete="off"
                        type="number"
                        formControlName="estimatedTime"
                        required
                        matInput
                        #tiempo
                        oninput="this.value = this.value.slice(0,2)"
                        placeholder="tiempo_estimado (horas)"
                        />
                      <mat-hint>{{ tiempo.value.length }}/2</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Referencia Factura</mat-label>
                      <input
                        autocomplete="off"
                        type="text"
                        formControlName="invoiceReference"
                        matInput
                        #ref_factura
                        maxlength="20"
                        placeholder="Referencia Factura"
                        />
                      <mat-hint>{{ ref_factura.value.length }}/20</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
                <div class="default-row">
                  <div class="row-item">
                    <mat-form-field>
                      <mat-label>Descripción</mat-label>
                      <textarea
                        autocomplete="off"
                        formControlName="description"
                        matInput
                        required
                        #descripcion
                        maxlength="10000"
                        placeholder="Descripción"
                        rows="3"
                        class="min-rows-2 resizable-textarea"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="15"
                        >
                      </textarea>
                      <mat-hint>{{ descripcion.value.length }}/10000</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              @if (data.action == 'edit') {
                <div style="flex: 0.2">
                  <button mat-mini-fab color="warn" type="submit">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button
                    mat-mini-fab
                    color="accent"
                    (click)="deleteOT($event)"
                    style="margin-top: 10px"
                    >
                    <mat-icon>delete</mat-icon>
                  </button>
                  @if (screen) {
                    <button
                      mat-mini-fab
                      color="accent"
                      type="button"
                      (click)="print($event, formOT.value)"
                      style="margin-top: 10px"
                      >
                      <mat-icon>print</mat-icon>
                    </button>
                  }
                  <button
                    mat-mini-fab
                    color="primary"
                    (click)="back($event)"
                    style="margin-top: 10px"
                    >
                    <mat-icon>reply</mat-icon>
                  </button>
                </div>
              }
            </div>
            @if (data.action != 'edit') {
              <div
                style="display: flex; flex-direction: row; justify-content: center"
                >
                <button
                  [disabled]="buttonActive"
                  type="submit"
                  style="width: 70%; margin-top: 25px; align-self: center"
                  color="primary"
                  class="button-save mat-elevation-z5"
                  mat-raised-button
                  >
                  Continuar
                </button>
              </div>
            }
          </cdk-virtual-scroll-viewport>
        </form>
      }
    </mat-step>
    <!-- Step 4 Resources-->
    @if (inventoryModule && comboItemLength > 0) {
      <mat-step
        [stepControl]="validateResoruces"
        >
        @if (isMobile) {
          <div class="mobile-step-title">
            Recursos
          </div>
        }
        <form [formGroup]="validateResoruces">
          @if (!isMobile) {
            <ng-template matStepLabel>Recursos</ng-template>
          }
          <app-handler-items
            (listItemComplete)="saveResourcesInMemory($event)"
            (comboItemLength)="comboItemsLength($event)"
            [titleDialog]="'Recursos'"
            [headerDetails]="false"
            [acceptButton]="true"
            labelAcceptButton="Continuar"
            [itemsData]="resources"
            [urlItemCombo]="urlGetItems"
            >
          </app-handler-items>
          <div style="display: none">
            <mat-form-field>
              <input
                autocomplete="off"
                type="text"
                formControlName="resorucesAdd"
                matInput
                required
                />
            </mat-form-field>
          </div>
        </form>
      </mat-step>
    }
    <!-- Step 5 Responsible-->
    <mat-step [stepControl]="formStepeFour">
      @if (isMobile) {
        <div class="mobile-step-title">
          Lugar de ejecución
        </div>
      }
      <form [formGroup]="formStepeFour" style="height: 70vh">
        @if (!isMobile) {
          <ng-template class="font" matStepLabel>Lugar de ejecución</ng-template>
        }
        <mat-form-field style="display: none">
          <input
            autocomplete="off"
            type="text"
            formControlName="responsibleType"
            matInput
            required
            />
        </mat-form-field>
        <app-button-icon
          style="width: 100%"
          [items]="buttonResponsible"
          (clickButton)="typeResponsible($event.id)"
        ></app-button-icon>
      </form>
    </mat-step>
    <!-- Step 6 Select Responsible-->
    <mat-step>
      @if (isMobile) {
        <div class="mobile-step-title">
          {{
          formStepeFour.get('responsibleType').value == "tercero"
          ? "Selección de tercero"
          : "Selección de usuarios"
          }}
        </div>
      }
      <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
        <div
        style="
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
          overflow: auto;
        "
          >
          @if (!isMobile) {
            <ng-template class="font" matStepLabel>{{
              formStepeFour.get('responsibleType').value == "tercero"
              ? "Selección de tercero"
              : "Selección de usuarios"
            }}</ng-template>
          }
          @if (formStepeFour.get('responsibleType').value == 'tercero') {
            <div
              style="width: 100%"
              >
              <data-table
                [title]="titleTerceros"
                [columns]="columnasTerceros"
                [data]="dataTerceros"
                [configuration]="configurationTerceros"
                [reloadTable]="recargarTablaTerceros"
                (clickRow)="clickFilaTerceros($event)"
                [params]="paramsTerceros"
                [url]="urlGetTablaTerceros"
                >
              </data-table>
            </div>
          }
          @if (formStepeFour.get('responsibleType').value == 'usuario') {
            <div
              style="width: 100%"
              >
              <data-table
                [title]="titleUsuarios"
                [columns]="columnasUsuarios"
                [configuration]="configurationUsuarios"
                [reloadTable]="recargarTablaUsuarios"
                (clickRow)="clickFilaUsuarios($event)"
                [params]="[{ id: 'state', value: 1 }]"
                [url]="urlGetTablaUsuarios"
                >
              </data-table>
            </div>
          }
          <div style="margin: 10px 10px 0 0">
            <mat-chip-listbox #chipList aria-label="Fruit selection">
              @for (data of chipResponsable; track data) {
                <mat-chip-option
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(data)"
                  >
                  {{ data.nombre }}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>
          <div
            class="d-flex flex-direction-row w-100"
            [style.justify-content]="isMobile ? 'center': 'space-between'"
            >
            <button
              [disabled]="buttonEnd"
              style="width: 45%; margin-top: 15px"
              color="primary"
              class="button-save mat-elevation-z5"
              (click)="finalizar(false)"
              mat-raised-button
              >
              Finalizar
            </button>
            @if (!isMobile) {
              <button
                [disabled]="buttonEnd"
                style="width: 45%; margin-top: 15px"
                color="warn"
                class="button-save mat-elevation-z5"
                (click)="finalizar(true)"
                mat-raised-button
                >
                Finalizar e imprimir
              </button>
            }
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </mat-step>
  </mat-stepper>
}

<!-- Update order -->
@if (data.action == 'edit') {
  <mat-tab-group>
    <mat-tab label="Orden de trabajo">
      <ng-container *ngTemplateOutlet="formWorkOrder"></ng-container>
    </mat-tab>
    @if (inventoryModule) {
      <mat-tab label="Recursos">
        <div class="mt-5">
          <data-table
            [title]="'Recursos OT'"
            [columns]="columnsResouces"
            [configuration]="configurationResouces"
            [reloadTable]="reloadResouces"
            [url]="urlGetTablaResources"
            [params]="paramsResources"
            (delete)="deleteResources($event)"
            (add)="addResources($event)"
            (edit)="editResources($event)"
            (internalData)="dataResources($event)"
            >
          </data-table>
        </div>
      </mat-tab>
    }
    <mat-tab label="Encargados">
      <div style="margin-top: 30px">
        @if (bodyResponsable.length == 0) {
          <div
        style="
          margin: 10px 0 10px 0;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
            >
            <mat-slide-toggle
              (change)="changeToggle($event)"
              [(ngModel)]="isChecked"
              >{{ labelToggle }}</mat-slide-toggle
              >
            </div>
          }
          <data-table
            [title]="titleUsuariosOrden"
            [columns]="columnasUsuariosOrden"
            [configuration]="configurationUsuariosOrden"
            [reloadTable]="recargarTablaUsuariosOrden"
            (add)="agregarUsuariosOrden($event)"
            (delete)="eliminarUsuariosOrden($event)"
            (internalData)="userOrdersDataTable($event)"
            [url]="urlGetTablaUsuariosOrdenes"
            [params]="paramsResources"
          ></data-table>
        </div>
      </mat-tab>
      <mat-tab label="Comentarios" >
        <div class="mt-5">
          <data-table
            [title]="titleC"
            [columns]="columnsComments"
            [configuration]="configurationComments"
            [reloadTable]="reloadComments"
            [url]='EndpointDictionary.WorkOrder.COMMENTS.TABLE'
            [params]="paramsComments"
            (delete)="deleteComments($event)"
            (add)="addComments($event)"
            (edit)="editComments($event)"
            (fileIconClick)="onFileIconClick($event)"
            >
          </data-table>
        </div>
      </mat-tab>
    </mat-tab-group>
  }


</div>

  <ng-template #formWorkOrder>
    <form
      [formGroup]="formOT"
    (ngSubmit)="
      formOT.valid
        ? data.action != 'edit'
          ? stepper.next()
          : saveOt(formOT.value)
        : errorMessage()
    "
      style="overflow: auto"
      >
      <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
        <div style="display: flex; width: 100%; margin-top: 10px">
          <div [style.flex]="data.action == 'edit' ? 10 : 12">
            <div class="first-row">
              @if (data.action == 'edit') {
                <div class="row-item">
                  <mat-form-field>
                    <mat-label># orden</mat-label>
                    <input
                      [value]="data.body.consecutive"
                      matInput
                      readonly
                      placeholder="# orden"
                      />
                  </mat-form-field>
                </div>
              }
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Marca</mat-label>
                  <input
                    [value]="equipo.brand"
                    matInput
                    readonly
                    placeholder="Marca"
                    />
                </mat-form-field>
              </div>
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Código equipo</mat-label>
                  <input
                    [value]="equipo.code"
                    matInput
                    readonly
                    placeholder="Código equipo"
                    />
                </mat-form-field>
              </div>
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Componente</mat-label>
                  <mat-select formControlName="componentId" required>
                    @for (data of componentes; track data) {
                      <mat-option
                        [value]="data.id"
                        >
                        {{ data.name }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error>Campo requerido</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="default-row">
              <div class="row-item">
                <mat-form-field [appOpenDatepickerOnClick]="pickerExecuteDate2">
                  <mat-label>Fecha ejecución</mat-label>
                  <input
                    [matDatepicker]="pickerExecuteDate2"
                    autocomplete="off"
                    matInput
                    required
                    formControlName="executionDate"
                    (ngModelChange)="checkDateRange($event)"
                    />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerExecuteDate2">
                  </mat-datepicker-toggle>
                  <mat-datepicker
                    #pickerExecuteDate2
                    [touchUi]="isMobile ? true : false"
                  ></mat-datepicker>
                  <mat-error>Campo requerido</mat-error>
                </mat-form-field>
              </div>

              <div class="row-item">
                <mat-form-field>
                  <mat-label>Costo Mantenimiento</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    appThousandSeparator
                    formControlName="cost"
                    matInput
                    #costo
                    oninput="this.value = this.value.slice(0,10)"
                    placeholder="Costo Mantenimiento"
                    />
                  <mat-hint>{{ costo.value.length }}/10</mat-hint>
                </mat-form-field>
              </div>

              <div class="row-item">
                <combos
                  [configuration]="combosConfigauthorize"
                  [reloadCombo]="reloadComboauthorize"
                  [required]="true"
                  [filter]="true"
                  [disabled]="data.action == 'edit'"
                  [control]="formOT.get('authorizesId')"
                  >
                </combos>
              </div>
            </div>

            <div class="default-row">
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Medidor actual (horas/km/ciclos)</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    appThousandSeparator
                    formControlName="currentOdometer"
                    required
                    matInput
                    #o_actual
                    oninput="this.value = this.value.slice(0,7)"
                    placeholder="Medidor actual (horas/km/ciclos)"
                    />
                  <mat-hint>{{ o_actual.value.length }}/8</mat-hint>
                </mat-form-field>
              </div>

              <div class="row-item">
                <combos
                  [configuration]="combosConfigResponsable"
                  [reloadCombo]="reloadComboResponsable"
                  [required]="true"
                  [filter]="true"
                  [disabled]="data.action == 'edit'"
                  [control]="formOT.get('responsibleId')"
                  >
                </combos>
              </div>
              @if (!inventoryModule) {
                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Recursos</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      formControlName="resources"
                      matInput
                      required
                      #recursos
                      maxlength="255"
                      placeholder="Recursos"
                      />
                    <mat-hint>{{ recursos.value.length }}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>
              }
            </div>

            <div class="default-row">
              <div class="row-item">
                <mat-form-field>
                  <mat-label>tiempo_estimado (horas)</mat-label>
                  <input
                    autocomplete="off"
                    type="number"
                    formControlName="estimatedTime"
                    required
                    matInput
                    #tiempo
                    oninput="this.value = this.value.slice(0,2)"
                    placeholder="tiempo_estimado (horas)"
                    />
                  <mat-hint>{{ tiempo.value.length }}/2</mat-hint>
                  <mat-error>Campo requerido</mat-error>
                </mat-form-field>
              </div>
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Referencia Factura</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="invoiceReference"
                    matInput
                    #ref_factura
                    maxlength="20"
                    placeholder="Referencia Factura"
                    />
                  <mat-hint>{{ ref_factura.value.length }}/20</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="default-row">
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Descripción</mat-label>
                  <textarea
                    autocomplete="off"
                    formControlName="description"
                    matInput
                    required
                    #descripcion
                    maxlength="1000"
                    placeholder="Descripción"
                    rows="3"
                    class="min-rows-2 resizable-textarea"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="15"
                    >
                  </textarea>
                  <mat-hint>{{ descripcion.value.length }}/1000</mat-hint>
                  <mat-error>Campo requerido</mat-error>
                </mat-form-field>
              </div>

            </div>
          </div>

          @if (data.action == 'edit') {
            <div style="flex: 0.2">
              <button mat-mini-fab color="warn" type="submit">
                <mat-icon>save</mat-icon>
              </button>
              <button
                mat-mini-fab
                color="accent"
                (click)="deleteOT($event)"
                style="margin-top: 10px"
                >
                <mat-icon>delete</mat-icon>
              </button>
              @if (screen) {
                <button
                  mat-mini-fab
                  color="accent"
                  type="button"
                  (click)="print($event, formOT.value)"
                  style="margin-top: 10px"
                  >
                  <mat-icon>print</mat-icon>
                </button>
              }
              <button
                mat-mini-fab
                color="primary"
                (click)="back($event)"
                style="margin-top: 10px"
                >
                <mat-icon>reply</mat-icon>
              </button>
            </div>
          }
        </div>

        @if (data.action != 'edit') {
          <div
            style="display: flex; flex-direction: row; justify-content: center"
            >
            <button
              [disabled]="buttonActive"
              type="submit"
              style="width: 70%; margin-top: 25px; align-self: center"
              color="primary"
              class="button-save mat-elevation-z5"
              mat-raised-button
              >
              Continuar
            </button>
          </div>
        }
      </cdk-virtual-scroll-viewport>
    </form>
  </ng-template>
